var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnFlipBackwards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92258 0.410765C5.24802 0.736202 5.24802 1.26384 4.92258 1.58928L3.01183 3.50002H9.33332C12.555 3.50002 15.1667 6.11169 15.1667 9.33335C15.1667 12.555 12.555 15.1667 9.33332 15.1667H0.99999C0.539753 15.1667 0.166656 14.7936 0.166656 14.3334C0.166656 13.8731 0.539753 13.5 0.99999 13.5H9.33332C11.6345 13.5 13.5 11.6345 13.5 9.33335C13.5 7.03217 11.6345 5.16669 9.33332 5.16669H3.01183L4.92258 7.07743C5.24802 7.40287 5.24802 7.93051 4.92258 8.25594C4.59714 8.58138 4.0695 8.58138 3.74407 8.25594L0.410734 4.92261C0.0852973 4.59717 0.0852973 4.06953 0.410734 3.7441L3.74407 0.410765C4.0695 0.0853278 4.59714 0.0853278 4.92258 0.410765Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFlipBackwards);
export default __webpack_public_path__ + "static/media/icn-flip-backwards.2a44377d529013a40bb0aa13bcb5e322.svg";
export { ForwardRef as ReactComponent };